<template>
  <div>
    <h1 style="margin-bottom: 0; margin-left: 20px;">Новость</h1>
    <template v-if="!isLoading">
      <form @submit.prevent="createItem">
        <div class="field">
          <p><a href="/news/list">К списку</a></p>
        </div>
        <BaseInput
            v-model="item.title"
            label="Название новости"
            description=""
        ></BaseInput>

        <BaseInput
            v-model="item.link"
            label="Ссылка на новость"
            description="Например, https://vk.com/wall-170712784_1022 (должна начинаться на https)"
        ></BaseInput>

        <BaseInput
            v-model="item.image"
            label="Ссылка на изображение новости"
            description="Например, https://sun9-21.userapi.com/impg/BBjHbMBsRAi9jOTPmoJobRZk_90ZmOlbYJ9epw/7XlRqHT1qho.jpg?size=1920x1080&quality=95&sign=29f8b679f5b39774770d8ac6719a1048&type=album (должна начинаться на https). Кликаем правой кнопкой мыши по изображению и 'Копировать адрес изображения'. Вставляем полученный адрес в это поле."
        ></BaseInput>

        <div class="field">
          <label>Текст</label>
          <p>Необязательное поле, если указали ссылку на новость.</p>
          <editor
              :init="{
                  plugins: 'lists link paste visualchars code',
                  menubar:false,
                  toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent code',
                  apply_source_formatting:true,
                  entity_encoding: 'raw',
                }"
              v-model="item.text"
          ></editor>
        </div>

        <div style="width: 50%; margin-top: 15px;">
          <label style="display: block">Рубрики</label>
          <p>Необязательное поле, если указали ссылку на новость.</p>
          <Select
              v-model:value="item.rubric"
              :options="rubrics"
              labelInValue
              mode="multiple"
              size="middle"
              :filter-option="false"
              style="width: 100%"
              @search="fetchItems"
              :not-found-content="fetching ? undefined : null"
          >
            <template v-if="fetching" #notFoundContent>
              <Spin size="small"/>
            </template>
          </Select>
        </div>

        <p style="margin-top: 50px;">
          <button style="cursor: pointer" class="button3" type="submit">Сохранить</button>
        </p>
      </form>
    </template>
    <template v-else>
      <Spin></Spin>
    </template>

  </div>
</template>
<script>
import BaseInput from "./Base/BaseInput3";
import axios from "axios";
import {Select, Spin} from 'ant-design-vue';
import Editor from '@tinymce/tinymce-vue'

const entity = 'news';

export default {
  name: 'NewsComponent',
  data() {
    return {
      rubrics: [],
      fetching: false,
      isLoading: false,
      item: {
        'title': '',
        'text': '',
        'link': '',
        'image': '',
        'rubric': []
      }
    }
  },
  mounted() {
    this.getData();
  },
  components: {
    BaseInput,
    Select,
    Spin,
    Editor
  },
  methods: {
    async getData() {
      if (window.newsId.length > 0) {
        this.isLoading = true;
        axios.get('/api/'+entity+'/'+window.newsId).then((item) => {

          Object.keys(this.item).forEach(key => {
            if (item.data[key] === undefined) {
              item.data[key] = null;
            }
          });

          this.item = item.data;


          this.isLoading = false;

          const rubrics = item.data.rubric.map((val) => {
            return {
              label:val.title,
              value: '/api/rubrics/' + val.id
            }
          });
          this.item.rubric = rubrics;
        })
      }
    },
    createItem() {
      if (window.newsId.length > 0) {
        axios.patch('/api/' + entity + '/' + this.item.id, {
          'title': this.item.title,
          'text': this.item.text,
          'link': this.item.link,
          'image': this.item.image,
          'rubric': this.selected_rubrics
        }, {
          headers: {
            'Content-Type': 'application/merge-patch+json'
          }
        }).then(() => {
          this.item.title = '';
          this.mode = 'list'
          this.getData();
        })
      } else {
        axios.post('/api/' + entity, {
          'title': this.item.title,
          'text': this.item.text,
          'link': this.item.link,
          'image': this.item.image,
          'rubric': this.selected_rubrics
        }).then((item) => {
          location.replace('/news/create/'+item.data.id)
        })
      }

    },
    updateItem() {

    },
    async fetchItems(value) {
      this.fetching = true;

      await axios.get('/api/rubrics.json?name=' + value).then((data) => {
        this.rubrics = data.data.map((item) => {
          return {
            label: item.title,
            value: '/api/rubrics/' + item.id
          }
        });
      })

      this.fetching = false;
    },
  },
  computed: {
    rubric_options() {
      return this.item.rubric.map((val) => {
        return {
          value: '/api/rubrics/'+val.id,
          label: val.title
        }
      })
    },
    selected_rubrics() {
      return this.item.rubric.map((val) => {

        if (val.id) {
          return '/api/rubrics/'+val.id;
        } else {
          return val.value;
        }

      })
    }
  }
}
</script>

<style scoped>
.tox-notifications-container {
  display: none !important;
}
input[type=text] {
  max-width: none;
}
</style>